import React, { useEffect } from 'react';

/**
 * 순수 Tailwind 기반 모달 레이아웃 컴포넌트
 * @param {boolean} open - 모달 열림/닫힘 상태
 * @param {function} onClose - 모달 닫기 함수
 * @param {string} title - 모달 제목
 * @param {string} size - 모달 크기 ('sm', 'md', 'lg', 'xl', 'full')
 * @param {React.ReactNode} children - 모달 내용
 */
const BaseModal = ({ 
  open, 
  onClose, 
  title, 
  size = "md",
  children 
}) => {
  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && open) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden'; // 배경 스크롤 방지
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [open, onClose]);


  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center md:p-4">
      {/* 배경 오버레이 */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
      />
      
      {/* 모달 컨테이너 */}
      <div className={`relative w-full h-full md:w-[1180px] md:h-auto bg-white md:rounded-lg shadow-xl md:max-h-[90vh] flex flex-col justify-start items-start`}>
        {/* 헤더 */}
        {title && (
          <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
            <div className="w-full h-auto max-w-[1400px] pl-5 pr-2 py-4 inline-flex justify-start items-start gap-2">
              <div className="flex-1 flex justify-start items-center gap-2.5">
                <div className="flex-1 h-10 inline-flex flex-col justify-center items-start">
                  <div className="self-stretch justify-center text-zinc-700 text-2xl leading-[32px] font-semibold font-['Noto_Sans_KR'] tracking-wide">{title}</div>
                </div>
              </div>
              <div className="size-10 px-4 py-2 rounded-md flex justify-center items-center cursor-pointer hover:bg-zinc-100 transition-colors" onClick={onClose}>
                <div className="relative">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#71717A"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {/* 콘텐츠 */}
        <div className="w-full md:max-w-[1400px] overflow-y-auto flex-1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default BaseModal;
